/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import ajaxSchool from "../util/remote/ajaxSchool";
import ajaxStudentGroup from "../util/remote/ajaxStudentGroup";
import { useContext } from "react";
import AuthContext from "./AuthContext";
import ajaxStudent from "../util/remote/ajaxStudent";
import ajaxCallStation from "../util/remote/ajaxCallStation";
import ajaxStation from "../util/remote/ajaxStation";

const SchoolContext = React.createContext();

export const SchoolConsumer = SchoolContext.Consumer;

export const SchoolProvider = (props) => {
  const [schoolList, setSchoolList] = useState(false);
  const [schoolListByPage, setSchoolListByPage] = useState(false);
  const [schoolId, setSchoolId] = useState(null);
  const [schoolContactsCount, setSchoolContactsCount] = useState(false);

  const [studentCount, setStudentCount] = useState(false);
  const [stationCount, setStationCount] = useState(false);
  const [schoolStations, setSchoolStations] = useState([]);

  const [schoolsNumber, setSchoolsNumber] = useState(false);
  const { user } = useContext(AuthContext);
  const [recentSchools, setRecentSchools] = useState(false);
  const [schoolGroups, setSchoolGroups] = useState(false);
  const [data, setData] = useState({ page: "1" });
  const [schoolDetails, setSchoolDetails] = useState(false);
  const [page,setPage] = useState(1)
  const [meta,setMeta] = useState([])
  const [first, setFirst] = useState("");
  const [query, setQuery] = useState("");

  

  const [stationPage,setStationPage] = useState(1)
  const [stationMeta,setStationMeta] = useState([])
  const [stationFirst, setStationFirst] = useState("");
  const [loading,setLoading] = useState(false)
  const [loading2,setLoading2] = useState(false)
  const [loading3,setLoading3] = useState(false)


  const [schoolLogsToday, setSchoolLogsToday] = useState(false);
  const [schoolTermList, setSchoolTermList] = useState(false);

  useEffect(() => {
    getSchoolList();
    getRecentSchools();
    getSchoolsNumber();
    getTermsList();
  }, [data]);

  useEffect(() => {
    if (user) {
      getUserSchool();
    }
  }, [user]);

  useEffect(() => {
    if (schoolId) {
      
      countSchoolStudents();
      countSchoolStations();
      getGroups();
      countSchoolLogsToday();
      countSchoolContacts()
    }
  }, [schoolId]);

  useEffect(() => {
    if (schoolId) {
      getSchoolStations(stationPage);
    }
  }, [schoolId, stationPage]);

  const countSchoolStations = async () => {
    setStationCount(false);
    if (!schoolId) return;

    const server_response = await ajaxCallStation.callStation_count(schoolId);
    if (server_response.status === "OK") {
        setStationCount(server_response.details);
    } else {
        setStationCount("404");
    }
  };


  const getSchoolList = async () => {
    const server_response = await ajaxSchool.fetchSchoolList(data);
    if (server_response.status === "OK") {
      //store results
      setSchoolList(server_response.details);
    } else {
      //communicate error
      setSchoolList("404");
    }
  };

  const getSchoolListByPage = async (currentPage) => {
    setLoading(true);
    const server_response = await ajaxSchool.fetchSchools(currentPage);
    setLoading(false);
    if (server_response.status === "OK") {
      setFirst(server_response.details.meta.offset_count);
      setMeta(server_response.details.meta.list_of_pages);
      setSchoolListByPage(server_response.details.list || []);
    } else {
      setSchoolListByPage([]);
    }
  };

  

  

  const searchSchools = async (e) => {
    if (e) {
        e.preventDefault();
    }
    setLoading2(true);
    const server_response = await ajaxSchool.searchSchoolList(query, page);
    setLoading2(false);
    if (server_response.status === "OK") {
      setFirst(server_response.details.meta.offset_count);
      setMeta(server_response.details.meta.list_of_pages);
      setSchoolListByPage(server_response.details.list || []);
    } else {
      setSchoolListByPage([]);
    }    
  };

  

  const countSchoolStudents = async () => {
    setStudentCount(false);
    if (!schoolId) return;
    const server_response = await ajaxStudent.fetchStudentNumber(schoolId);
    if (server_response.status === "OK") {
        setStudentCount(server_response.details);
    } else {
        setStudentCount("404");
    }
};

  const getRecentSchools = async () => {
    const server_response = await ajaxSchool.fetchTodaySchools(data);
    if (server_response.status === "OK") {
      //store results
      setRecentSchools(server_response.details);
    } else {
      //communicate error
      setRecentSchools("404");
    }
  };

  const getGroups = async () => {
    if (!schoolId) return;
    const server_response = await ajaxStudentGroup.fetchGroupList(schoolId);
    if (server_response.status === "OK") {
      setSchoolGroups(server_response.details);
    } else {
      //communicate error
      setSchoolGroups("404");
    }
  };

  const getSchoolsNumber = async () => {
    setSchoolsNumber(false);
    const server_response = await ajaxSchool.fetchSchoolNumber();
    if (server_response.status === "OK") {
      //store results
      setSchoolsNumber(server_response.details);
    } else {
      //communicate error
      setSchoolsNumber("404");
    }
  };

  const getUserSchool = async () => {
    const server_response = await ajaxSchool.fetchUserSchool(user.user_id);
    
    if (server_response.status === "OK") {
      setSchoolDetails(server_response.details);
    }
  };

  const getSchoolStations =async(currentPage)=>{
    setLoading3(true)
    const server_response = await ajaxStation.fetchStationList(schoolId,currentPage);
    setLoading3(false)
    if(server_response.status==="OK"){
      setStationFirst(server_response.details.meta.offset_count);
      setStationMeta(server_response.details.meta.list_of_pages);
      setSchoolStations(server_response.details.list || []);
    } else {
      setSchoolStations([]);
    }
  }

  const countSchoolLogsToday = async () => {
    const server_response = await ajaxCallStation.countSchoolLogsToday(schoolId);
    if (server_response.status === "OK") {
      setSchoolLogsToday(server_response.details);
    } else {
      setSchoolLogsToday("404");
    }
  };

  const countSchoolContacts = async () => {
    const server_response = await ajaxSchool.countSchoolContacts(schoolId);
    if (server_response.status === "OK") {
      setSchoolContactsCount(server_response.details);
    } else {
      setSchoolContactsCount("404");
    }
  };

  const getTermsList = async () => {
      const server_response = await ajaxSchool.fetchSchoolTermsList(data);
      if (server_response.status === "OK") {
        //store results
        setSchoolTermList(server_response.details);
      } else {
        //communicate error
        setSchoolTermList("404");
      }
  };

  return (
    <SchoolContext.Provider
      value={{
        schoolList,
        schoolStations,
        recentSchools,
        schoolGroups,
        schoolsNumber,
        schoolDetails,
        schoolListByPage,
        studentCount,
        stationCount,
        schoolContactsCount,
        loading,
        loading2,
        loading3,
        stationFirst,
        stationMeta,
        stationPage,
        schoolLogsToday,
        page,
        meta,
        first,
        query,
        schoolId,
        schoolTermList,
        setStationFirst,
        setStationMeta,
        setStationPage,
        setData,
        setPage,
        setMeta,
        setQuery,
        getSchoolList,
        getRecentSchools,
        getGroups,
        getSchoolsNumber,
        setSchoolDetails,
        getUserSchool,
        getSchoolListByPage,
        setSchoolId,
        searchSchools,
        getSchoolStations,
        countSchoolLogsToday,
        getTermsList
      }}
    >
      {props.children}
    </SchoolContext.Provider>
  );
};

export default SchoolContext;
